import {toPairs} from 'lodash'
import {Basic, Ventrata} from 'types'

export const convertUnitItemsToRequestUnitItems = (
  unitItems: Ventrata.UnitItem[],
  bookingActivityDetails?: Basic.BookingActivityDetails
): Ventrata.RequestUnitItem[] => {
  const result: Ventrata.RequestUnitItem[] = []

  for (const unitItem of unitItems) {
    const travelerActivityDetails = bookingActivityDetails ? bookingActivityDetails[unitItem.id] : {}

    result.push({
      unitId: unitItem.unitId,
      questionAnswers: toPairs(travelerActivityDetails).map(([questionId, value]) => ({questionId, value})),
    })
  }

  return result
}
